import { Divider, SubTitle, Chip, Shape, CustomLink, Body, styled } from '@teko/ds-desktop';
import { DeleteCircleColored, DownOutlined } from '@teko/ds-icon';
import React, { useState } from 'react';
import { t } from '../../i18n.es.js';
import { CategoriesFilter } from './CategoriesFilter.es.js';
import { FilterCollapse } from './FilterCollapse.es.js';
import { PriceFilter } from '../PriceFilter/PriceFilter.es.js';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
const VerticalFilter = ({
  filters = [],
  onClickOption,
  activeOptions = [],
  clearFilterLink,
  filterPrice,
  renderPriceFilter,
  onClearFilter,
  categoriesFilter,
  priceFilterFirst = false,
  collapsibleSections = false
}) => {
  const [priceExpanded, setPriceExpanded] = useState(true);
  if (!filters.length && !filterPrice)
    return null;
  const categoriesSection = !!categoriesFilter && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(CategoriesFilter, __spreadProps(__spreadValues({}, categoriesFilter), {
    collapsible: collapsibleSections
  })), /* @__PURE__ */ React.createElement(Divider, {
    color: "border",
    gap: 12
  }));
  const priceSection = filterPrice && /* @__PURE__ */ React.createElement(React.Fragment, null, collapsibleSections ? /* @__PURE__ */ React.createElement(SectionHeader, {
    onClick: () => setPriceExpanded((prev) => !prev)
  }, /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium"
  }, t("Kho\u1EA3ng gi\xE1")), /* @__PURE__ */ React.createElement(CollapseChevron, {
    className: priceExpanded ? "expanded" : ""
  })) : /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium",
    marginBottom: "s8"
  }, t("Kho\u1EA3ng gi\xE1")), (!collapsibleSections || priceExpanded) && (renderPriceFilter ? renderPriceFilter(filterPrice) : /* @__PURE__ */ React.createElement(PriceFilter, {
    max: filterPrice.max,
    min: filterPrice.min,
    step: filterPrice.step,
    value: filterPrice.value,
    onFilter: filterPrice.onFilter
  })), /* @__PURE__ */ React.createElement(Divider, {
    color: "border",
    gap: 12
  }));
  return /* @__PURE__ */ React.createElement(Wrapper, null, (!!activeOptions.length || !!(categoriesFilter == null ? void 0 : categoriesFilter.activeOptions.length)) && /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(SubTitle, {
    level: 4,
    weight: "medium",
    marginBottom: "s12"
  }, t("B\u1ED9 l\u1ECDc \u0111\xE3 d\xF9ng")), /* @__PURE__ */ React.createElement(ActiveOptionsWrapper, null, activeOptions.map((option, index) => /* @__PURE__ */ React.createElement(Chip, {
    key: index,
    content: option.optionName || "",
    closable: true,
    onClick: () => onClickOption == null ? void 0 : onClickOption(option),
    onClose: () => onClickOption == null ? void 0 : onClickOption(option),
    closeIcon: /* @__PURE__ */ React.createElement(DeleteCircleColored, null),
    style: { cursor: "pointer" }
  })), categoriesFilter == null ? void 0 : categoriesFilter.activeOptions.map((cat, index) => /* @__PURE__ */ React.createElement(Chip, {
    key: index,
    content: cat.name || "",
    closable: true,
    onClick: () => {
      var _a;
      return cat.code ? (_a = categoriesFilter == null ? void 0 : categoriesFilter.onRemoveCategory) == null ? void 0 : _a.call(categoriesFilter, cat.code) : null;
    },
    onClose: () => {
      var _a;
      return cat.code ? (_a = categoriesFilter == null ? void 0 : categoriesFilter.onRemoveCategory) == null ? void 0 : _a.call(categoriesFilter, cat.code) : null;
    },
    closeIcon: /* @__PURE__ */ React.createElement(DeleteCircleColored, null),
    style: { cursor: "pointer" }
  }))), /* @__PURE__ */ React.createElement(Shape, {
    onClick: (e) => {
      if (onClearFilter) {
        e.preventDefault();
        onClearFilter == null ? void 0 : onClearFilter();
      }
    },
    style: {
      cursor: onClearFilter || clearFilterLink ? "pointer" : "default"
    }
  }, /* @__PURE__ */ React.createElement(CustomLink, __spreadValues({}, clearFilterLink), /* @__PURE__ */ React.createElement(Body, {
    weight: "regular",
    color: "error500"
  }, t("X\xF3a b\u1ED9 l\u1ECDc"))), /* @__PURE__ */ React.createElement(Divider, {
    color: "border",
    gap: 12
  }))), priceFilterFirst ? /* @__PURE__ */ React.createElement(React.Fragment, null, priceSection, categoriesSection) : /* @__PURE__ */ React.createElement(React.Fragment, null, categoriesSection, priceSection), filters.map((filter, index) => {
    return /* @__PURE__ */ React.createElement(React.Fragment, {
      key: index
    }, /* @__PURE__ */ React.createElement(FilterCollapse, {
      onClickOption,
      active: index < 6,
      filter,
      activeOptions
    }), index < filters.length - 1 && /* @__PURE__ */ React.createElement(Divider, {
      color: "border",
      gap: 12
    }));
  }));
};
const Wrapper = styled.div(({ theme }) => `
  border-radius: ${theme == null ? void 0 : theme.borderRadius.m};
  padding: ${theme == null ? void 0 : theme.spacing.s12};
  background: ${theme == null ? void 0 : theme.colors.white};
  display: flex;
  flex-direction: column;
`);
const ActiveOptionsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.25rem;
  margin-bottom: 0.5rem;
`;
const SectionHeader = styled.div(({ theme }) => `
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 1.5rem;
  margin-bottom: ${theme == null ? void 0 : theme.spacing.s12};
  cursor: pointer;
  user-select: none;
`);
const CollapseChevron = styled(DownOutlined)`
  transition: transform 0.2s;
  &.expanded {
    transform: rotate(180deg);
  }
`;

export { VerticalFilter };
